import { z } from 'zod';

import type { TargetDevicesApiItem, TargetDevicesQuery } from './-query/type';

const DEVICE_GENRES = [
  'WORKSTATION',
  'LAPTOP',
  'MOBILE',
  'TABLET',
  'MONITOR',
  'SERVER',
  'OTHER',
] as const satisfies readonly TargetDevicesApiItem['genre'][];

const DEVICE_STATUSES = [
  'IN_DISTRIBUTION',
  'IN_STOCK',
  'IN_USED',
  'IN_PLACED',
  'IN_TROUBLED',
  'DECOMMISSIONED',
  'DELETED',
] as const satisfies readonly NonNullable<
  TargetDevicesQuery['statuses']
>[number][];

const SORTABLE_COLUMNS = [
  'DEVICE_NAME',
  'USER_NAME',
  'DEVICE_TAG',
  'SERIAL_NUMBER',
  'STATUS',
  'PROCURED_AT',
  'PLACE',
  'HAS_INVENTORY_LABEL',
  'RESPONSIBLE_PERSON_NAME',
  'PERSONAL_OWNER_NAME',
  'LAST_INVENTORY_DATE',
] as const satisfies readonly NonNullable<TargetDevicesQuery['orderBy']>[];

const deviceGenreSchema = z.enum(DEVICE_GENRES);

export const deviceTargetsSearchSchema = z.object({
  page: z.coerce.number().min(1).optional().default(1),
  pageSize: z.coerce.number().min(1).optional().default(100),
  freeText: z.string().optional(),
  genres: z.array(deviceGenreSchema).optional(),
  hasInventoryLabel: z.boolean().optional(),
  statuses: z.array(z.enum(DEVICE_STATUSES)).optional(),
  procuredFrom: z.string().optional(),
  procuredTo: z.string().optional(),
  placeIds: z.array(z.string()).optional(),
  sortColumn: z.enum(SORTABLE_COLUMNS).optional(),
  sortOrder: z.enum(['asc', 'desc']).optional(),
});

export type DeviceTargetsSearch = z.infer<typeof deviceTargetsSearchSchema>;
